export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">关于我们</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            了解51网址导航的初心与使命
          </p>
        </div>

        <div className="max-w-[720px] mx-auto text-center">
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            51网址导航诞生于互联网信息过载的时代。我们深知，面对海量网站和碎片化资讯，
            用户最需要的是一个简洁、高效、可信赖的上网导航平台。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            通过聚合网址导航123、123导航、导航123等数字标识快捷入口，我们打造了网址123
            这个易记好用的核心体验，并持续追踪全网热点事件与吃瓜资讯，让用户在第一时间掌握
            最新动态。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            无论是找网站、追热点、看评论，还是获取实用工具入口，51网址导航都致力于成为你
            上网的第一站。简单、快速、可靠——这是我们对每一位用户的承诺。
          </p>
        </div>
      </div>
    </section>
  );
}